/**
 * Product Info Modal Handler
 * Handles opening and closing of product information modals
 */

class ProductInfoModal {
  constructor() {
    this.init();
  }

  init() {
    // Handle modal open buttons
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-modal-target]');
      if (button) {
        event.preventDefault();
        const modalId = button.getAttribute('data-modal-target');
        this.openModal(modalId);
      }
    });

    // Handle modal close buttons
    document.addEventListener('click', (event) => {
      const closeButton = event.target.closest('[data-modal-close]');
      if (closeButton) {
        event.preventDefault();
        const modalId = closeButton.getAttribute('data-modal-close');
        this.closeModal(modalId);
      }
    });

    // Handle clicking outside modal to close
    document.addEventListener('click', (event) => {
      if (event.target.classList.contains('product-info-modal')) {
        event.preventDefault();
        this.closeModal(event.target.id);
      }
    });

    // Handle escape key to close modal
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        const openModals = document.querySelectorAll('.product-info-modal[open]');
        openModals.forEach(modal => {
          this.closeModal(modal.id);
        });
      }
    });
  }

  openModal(modalId) {
    const modal = document.getElementById(modalId);
    const body = document.getElementsByTagName("body")[0];
    const main = document.getElementsByTagName("main")[0]
    if (modal) {
      modal.show()
    }
    if(body) {
      body.style.overflow = "hidden";
    }
    if(main) {
      main.style.zIndex = "12";
    }
  }

  closeModal(modalId) {
    const modal = document.getElementById(modalId);
    const body = document.getElementsByTagName("body")[0];
    const main = document.getElementsByTagName("main")[0]


    if (modal) {
      modal.close()
    }
     if(body) {
      body.style.overflow = "unset";
    }
    if(main) {
      main.style.zIndex = "0";
    }
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new ProductInfoModal();
});

// Also initialize on section load (for theme editor)
document.addEventListener('shopify:section:load', () => {
  new ProductInfoModal();
});
